import type { JSX } from 'react';

import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { PetitionQRCode } from './components/PetitionQRCode';
import { PetitionQRCodeDownloadLink } from './components/PetitionQRCodeDownloadLink';

type PetitionQRCodeDownloadProps = {
	slugOrId: string;
	displaySize: number;
	displayType: QrCodeType;
	downloadType: QrCodeType;
	downloadSize: number;
	descriptionText: string;
	downloadLinkText: string;
	downloadFilename?: string;
	onDownload?: () => Promise<void>;
};
/*
 Note that a copy of this component exists at:
 apps/front-end/src/app/pages/starterDashboardV2/shared/components/qrcode/PetitionQRCodeDownload.tsx

 That duplicated version, doesn't use any legacy design system components, and has a slightly different layout
 to better fit the petition dashboard's design. If you are making changes to this component, please consider
 whether those changes should also be applied to the other version or the other way around.
 */
export function PetitionQRCodeDownload({
	slugOrId,
	displaySize,
	displayType,
	downloadSize,
	downloadType,
	descriptionText,
	downloadLinkText,
	downloadFilename,
	onDownload,
}: PetitionQRCodeDownloadProps): JSX.Element {
	return (
		<Flex sx={{ gap: '16' }}>
			<div sx={{ flexShrink: 0 }}>
				<PetitionQRCode slugOrId={slugOrId} size={displaySize} type={displayType} />
			</div>
			<Flex sx={{ flexDirection: 'column', gap: 8 }}>
				<Text>{descriptionText}</Text>
				<PetitionQRCodeDownloadLink
					slugOrId={slugOrId}
					size={downloadSize}
					type={downloadType}
					onDownload={onDownload}
					filename={downloadFilename}
				>
					{downloadLinkText}
				</PetitionQRCodeDownloadLink>
			</Flex>
		</Flex>
	);
}
